
import { ErrorHandler, Injectable } from '@angular/core';
import {NewRelicService} from './newRelic.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private newRelicService: NewRelicService) {}

  handleError(error: any): void {
    console.error('Error capturado por GlobalErrorHandler:', error);

    // Enviar error a New Relic
    this.newRelicService.noticeError(error, {
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href
    });

    //
  }
}
